export default {
  onExperienceStart: ({ eventCategory, eventLabel }: { eventCategory: string, eventLabel: string }) => ({
    event: 'loadEventData',
    eventCategory,
    eventAction: 'Experience Start',
    eventLabel,
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  })
}
